import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lock20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M9.25 11.5V14.5H10.75V11.5H9.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.25 5V7.75H4.04167C3.26498 7.75 2.75 8.41791 2.75 9.09375V17.4062C2.75 18.0821 3.26498 18.75 4.04167 18.75H15.9583C16.735 18.75 17.25 18.0821 17.25 17.4062V9.09375C17.25 8.41791 16.735 7.75 15.9583 7.75H14.75V5C14.75 2.33579 12.6642 0.25 10 0.25C7.33579 0.25 5.25 2.33579 5.25 5ZM10 1.75C8.16421 1.75 6.75 3.16421 6.75 5V7.75H13.25V5C13.25 3.16421 11.8358 1.75 10 1.75ZM4.25 9.25V17.25H15.75V9.25H4.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lock20.displayName = 'Lock20';
export default Lock20;
